// What the booking card asks for before the guest can continue: the dates,
// then the age of every child. A single apartment needs no choice, so it says
// when it is not available; hotels and aparthotels ask for rooms.
export const bookingHint = ({
  arrivalDate,
  departureDate,
  childAgesComplete = true,
  singleApartment,
  hasRooms,
  groupCovered,
}) => {
  if (!arrivalDate) return { key: "select_arrival_date", fallback: "Select your arrival date" };
  if (!departureDate) return { key: "select_departure_date", fallback: "Select your departure date" };
  if (!childAgesComplete) {
    return { key: "child_age_required", fallback: "Select the age of the child." };
  }
  if (!hasRooms) {
    return singleApartment
      ? { key: "no_availability_message", fallback: "No availability for the selected dates." }
      : { key: "select_room_hint", fallback: "Please select a room to continue" };
  }
  if (!groupCovered) return { key: "select_rooms_for_all_guests" };

  return null;
};
